const getProductAttributesByFacets = (facets, attributes, locale) => {
  if (!facets || facets.length === 0 || !attributes || attributes.length === 0 || !locale) {
    console.error(`Something went wrong trying to match product attributes to facets`);
    return [];
  }
  const facetsToFilter = facets.filter((facet) => facet.attribute.startsWith("filterableAttributes")).map((facet) => {
    const attribute = facet.isLocalized ? `${facet.attribute}_${locale}` : facet.attribute;
    return { attribute, id: facet.id, type: facet.type || "optional" };
  });
  return attributes.reduce((prev, attribute) => {
    const facet = facetsToFilter.find(
      (facet2) => facet2.id === (attribute.name || attribute.specificationAttribute)
    );
    if (facet) {
      prev.push({ id: facet.attribute, value: attribute.value, type: facet.type });
    }
    return prev;
  }, []);
};
export {
  getProductAttributesByFacets
};
//# sourceMappingURL=get-product-attributes-from-facets.js.map
